import React from 'react';
import {Tabs,Spin} from 'antd';
import {getMySDK} from 'actions/sdk';
import SDKList from './SDKList';
const { TabPane } = Tabs;

const tabMap = [
    {key:'collect',name:'Face Collection SDK'},
    {key:'idcard',name:'Card Collection SDK'}
];

class SDKDownload extends React.Component {
    state = {
        loading:true,
        data:{}
    }
    componentDidMount(){
        getMySDK().then(res=>{
            this.setState({data:res.data,loading:false});
        });
    }

    render() {
        const {data,loading} = this.state;
        return (
            <div>
                <Spin spinning={loading}>
                    <div style={{background:'#fff',padding:'16px 24px 24px 24px'}}>
                        <Tabs defaultActiveKey="collect">
                            {tabMap.map(item=>{
                                const sdkData = data[item.key];
                                if(!sdkData) return null;
                                return (
                                    <TabPane tab={item.name} key={item.key}>
                                        <SDKList data={sdkData} />
                                    </TabPane>
                                );
                            })}

                        </Tabs>
                    </div>
                </Spin>
            </div>
        );
    }
}

export default SDKDownload;



// WEBPACK FOOTER //
// ./src/pages/SDKDownload/index.js